// Candidate's test: the question they are currently answering (mode 'test')
export function parseCertification(json) {
  return {
    certificationQuestionId: json.idCertificationQuestion,
    certificationUserId: json.idCertificationUserTest,
    formId: json.idForm,
    supplierId: json.user.idUser,
    certificationId: json.idCertification,
    certificationTitle: json.certificationTitle,
    columns: (json?.columns || []).map((column) => ({
      name: column.name,
      data: column.data,
      type: column.type,
    })),
    answer: json?.answer,
  };
}

// Manager publish flow: a question of the referential, whose reference answer is being defined
export function parseCertificationQuestion(json) {
  return {
    certificationQuestionId: json.idCertificationQuestion,
    certificationId: json.idCertification,
    formId: json.certification.form.idForm,
    certificationTitle: json.certification.name,
    columns: (json?.inputs || []).map((column) => ({
      name: column.name,
      data: column.data,
      type: column.type,
    })),
    answer: json?.answer,
    json: json?.answer,
  };
}

// Read-only consultation: a candidate's recorded answer to a certification question
export function parseAnswerCertification(json) {
  return {
    certificationQuestionId: json.idCertificationQuestion,
    certificationId: json.idCertification,
    formId: json.idForm,
    certificationTitle: json.certificationTitle,
    columns: (json?.columns || []).map((column) => ({
      name: column.name,
      data: column.data,
      type: column.type,
    })),
    answer: json?.answer ?? { blocks: [], data: [], fields: [] },
    json: json?.answer ?? { blocks: [], data: [], fields: [] },
  };
}
